/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_Pg_P4_DInputs */

const en_mk_sec_pg_p4_d = /** @type {(inputs: Mk_Sec_Pg_P4_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sensitive actions are recorded with actor, time and target. Every piece of agent work has a step-by-step transcript.`)
};

const id_mk_sec_pg_p4_d = /** @type {(inputs: Mk_Sec_Pg_P4_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aksi sensitif tercatat dengan pelaku, waktu, dan sasarannya. Setiap kerja agen punya transkrip langkah demi langkah.`)
};

/**
* | output |
* | --- |
* | "Sensitive actions are recorded with actor, time and target. Every piece of agent work has a step-by-step transcript." |
*
* @param {Mk_Sec_Pg_P4_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_pg_p4_d = /** @type {((inputs?: Mk_Sec_Pg_P4_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_Pg_P4_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_pg_p4_d(inputs)
	return en_mk_sec_pg_p4_d(inputs)
});